<template>
  <div class="site_detail" v-if="isRouterAlive">
    <van-sticky>
      <van-nav-bar title="写字楼详情" left-arrow @click-left="goback()" />
    </van-sticky>
    <!-- 视频+swiper -->
    <video controls preload="auto" :poster="detailData.videoList[0].thumbnailUrl"
      style="width: 100%; height: 200px; object-fit: contain" :src="detailData.videoList[0].url"
      v-if="isSwiper === 0 && detailData.videoList.length > 0"></video>
    <van-swipe v-else @change="changeSwiper" class="my-swipe" :show-indicators="false" :autoplay="3000"
      indicator-color="white">
      <van-swipe-item v-for="(images, indexs) in detailData.imageList" :key="indexs">
        <van-image height="100%" width="100%" :src="images.url" fit="cover" @click="showPic(images.url)" />
      </van-swipe-item>
    </van-swipe>
    <div class="detail_header">
      <div class="header_indicator">
        <div class="indicator">
          <div v-if="detailData.videoList.length > 0" :class="[isSwiper === 0 ? 'active' : '']" @click="isSwiper = 0">
            视频
          </div>
          <div v-if="detailData.imageList.length > 0" :class="[isSwiper === 1 ? 'active' : '']" @click="isSwiper = 1">
            图片( {{ isSwiperIndex }} / {{ detailData.imageList.length }} )
          </div>
        </div>
      </div>
    </div>
    <!-- 详情内容 -->
    <div class="detail_centent">
      <div class="content_name line2">
        {{ detailData.name }}
      </div>
      <div class="centent_data">
        <div class="data_number line1">
          <div class="line1">
            <span class="fs20">{{ detailData.propertyFee }}</span> 元/㎡/天
          </div>
          <div class="line1">{{ detailData.paymentType }}</div>
        </div>
        <div class="data_number">
          <div class="line1">
            <span class="fs20">{{ detailData.monthlyRent }}</span>元/月
          </div>
          <div>月租金</div>
        </div>
        <div class="data_number">
          <div class="line1">
            <span class="fs20">{{ detailData.area }}</span>㎡
          </div>
          <div>面积</div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item">
          <span>位置</span>
          <div>{{ detailData.position }}-{{ detailData.district }}</div>
        </div>
        <div class="list_item_between">
          <div class="between">
            <span>类型</span>
            <div>{{ detailData.type_name }}</div>
          </div>
          <div class="between">
            <span>等级</span>
            <div>{{ detailData.level_name }}</div>
          </div>
        </div>
        <div class="list_item">
          <span>楼层</span>
          <div>{{ detailData.floor_name }}</div>
        </div>
        <div class="list_item_between">
          <div class="between">
            <span>注册</span>
            <div>{{ detailData.register_name }}</div>
          </div>
          <div class="between">
            <span>使用率</span>
            <div>>{{ detailData.utilizationRate }}%</div>
          </div>
        </div>
        <div class="list_item">
          <span>工位数</span>
          <div>容纳{{ detailData.workstation }}个</div>
        </div>
        <div class="list_item">
          <span>装修</span>
          <div>{{ detailData.renovation_name }}装修</div>
        </div>
        <div class="list_item">
          <span>支付</span>
          <div>{{ detailData.paymentType }}</div>
        </div>
        <div class="list_item">
          <span>物业费</span>
          <div>{{ detailData.propertyFee }}元/㎡/月</div>
        </div>
        <div class="list_item">
          <span>租期</span>
          <div>{{ detailData.rentFree }}</div>
        </div>
      </div>
      <div class="content_tag">
        <van-tag plain size="medium" color="#999" v-for="itemss in detailData.siteCharacteristics_name" :key="itemss">{{
            itemss
        }}</van-tag>
      </div>
      <div class="content_title">房源介绍</div>
      <div class="content_desc">{{ detailData.listingDetails }}</div>
      <div class="content_title">{{ detailData.address }}</div>
      <div class="fs14 color999 m-b20">
        {{ detailData.district }}-{{ detailData.position }} 
      </div>
      <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height: 300px" :scroll-wheel-zoom="true">
      </baidu-map>
      <van-button style="margin-top:20px;" block color="#0CADFC" @click="toMapLocation">导航位置</van-button>
      <div class="content_title">大家都在看</div>
      <div class="content_tabname">
        <div :class="[isCheck ? 'active' : '']" @click="isCheck = !isCheck">
          相似房源
          <span v-if="isCheck"></span>
        </div>
        <div :class="[!isCheck ? 'active' : '']" @click="isCheck = !isCheck">
          该楼盘其他房源
          <span v-if="!isCheck"></span>
        </div>
      </div>
      <!-- 列表菜单栏 -->
      <div class="home_list">
        <div class="list_item" v-for="(item, index) in isCheck ? detailData2 : detailData3" :key="index"
          @click="toSiteDetail(item.id)">
          <div class="item_content">
            <div class="content_img">
              <van-image height="100%" width="100%" :src="
                item.videoList.length > 0
                  ? item.videoList[0].thumbnailUrl
                  : item.coverImageUrl
              " fit="cover" />
              <van-icon v-if="item.videoList.length > 0" size="15" name="play" color="#fff" />
            </div>
            <div class="content_detail">
              <div class="fs15 line1 font-weightbold">
                {{ item.name }}
              </div>
              <div class="fs12 color666 p-b10">
                {{ item.district }}•{{ item.position }}
              </div>
              <div class="detail_tag">
                <van-tag color="#1A85D2" plain v-for="site in item.siteCharacteristics_name" :key="site">{{ site }}
                </van-tag>
              </div>
              <div class="detail_number">
                <div class="number">
                  <div class="fs16 coloree0a24">{{ item.monthlyRent }}</div>
                  <div class="fs12 coloree0a24">元/㎡/月</div>
                  <div class="fs14 color000 m-l20">{{ item.area }}㎡</div>
                </div>
                <!-- <div class="fs18 color999">广告</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部导航栏 -->
    <div class="detail_navbar">
      <div class="navbar_lsit">
        <van-icon :name="isCollect" size="15" @click="collect" />
        收藏
      </div>
      <div class="navbar_lsit" @click="shareFriendTip">
        <van-icon name="share-o" size="15" />
        分享
      </div>
      <van-button round block color="#0CADFC" @click="toSiteSubscribe">立即预约</van-button>
      <van-button round block color="#FFA001" @click="toSiteLease">立即租赁</van-button>
    </div>

    <div @click="showPicBox = false" v-if="showPicBox" style="position:fixed;top:0px;left:0px;width: 100%;height: 100%;background: rgba(0,0,0,0.5);z-index:10">
        <van-image
        @click="showPicBox = false"
          width="100%"
          :src="targetUrl"
          height="100%"
          fit="scale-down"
        />
    </div>
  </div>
</template>
<script>
import Video from "../place/components/video";
import { Button, Icon, Swipe, SwipeItem, Image, Tag } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Tag.name]: Tag,
    Video,
  },
  data() {
    return {
      targetUrl:'',
      showPicBox:false,
      videoUrl: "@/assets/test.mp4",
      ak: "XYGaAE5iabNQYtwv9nivEdn9BpyfHWHw", // 百度的地图密钥
      myMap: null,
      active: 1,
      total: 4,
      images: [
        "/static/images/index_bg.jpg",
        "/static/images/index_list_01.jpg",
      ],
      content: "房源详情",
      isSwiper: 0,
      isSwiperIndex: 1,
      detailData: [],
      detailData2: [],
      detailData3: [],
      detailId: 0,
      isCheck: true,
      isRouterAlive: true,

      center: { lng: "", lat: "" }, //lng代表纬度 lat代表经度
      zoom: 19,

      //必须配置项，从接口获取
      appId: "",
      timestamp: "",
      noncstr: "",
      signatureInfo: "",
      // 自配项
      imgurl: "", //分享图片（如分享出来链接上显示的小图标）
      url: "", //分享地址（如分享出来一个链接，点链接要跳的页面地址）
      title: "",
      desc: "",
      isCollect:'star-o',
    };
  },

  created() {
    this.detailId = this.$route.query.id;
    //场地中心-查看
    this.siteUserH5Detail(this.$route.query.id);
    //场地中心-查看
    this.pxalike(this.$route.query.id);
    //场地中心-查看
    this.pclistBySiteSupplierId(this.$route.query.id);
    //获取分享配置参数
    this.shareInfo();
  },

  watch: {
    // 利用watch方法检测路由变化：
    $route: function (to, from) {
      // 拿到目标参数 to.query.id 去再次请求数据接口
      this.detailId = to.query.id;
      //场地中心-查看
      this.siteUserH5Detail(to.query.id);
      //场地中心-查看
      this.pxalike(to.query.id);
      //场地中心-查看
      this.pclistBySiteSupplierId(to.query.id);
    },
  },

  methods: {
    //放大图片
    showPic(url){
      this.targetUrl = url;
      this.showPicBox = !this.showPicBox;
    },

    shareInfo() {
      let that = this;
      that.$api
        .shareInfoAPI({ url: location.href.split("#")[0] })
        .then((res) => {
          if (res.data.code === 200) {
            //这些配置参数必填项，后面去调微信的pai是需要传的。
            that.appId = res.data.data.appid;
            that.timestamp = res.data.data.timeStamp;
            that.noncstr = res.data.data.nonceStr;
            that.signatureInfo = res.data.data.signature;
            that.shareFriend()
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    shareFriend() {
      let that = this;
      //当点击分享好友按钮时
      //怎么取图片的地址取决于你放图片的路径，你也可以用线上图片，也可以放在你们的服务器上。
      that.imgurl =
        that.detailData.videoList.length > 0 ?
          that.detailData.videoList[0].thumbnailUrl :
          that.detailData.coverImageUrl;
      that.url = window.location.href;
      that.title = that.detailData.name;
      that.desc = that.detailData.listingDetails;
      that.sharewxinit()
    },

    sharewxinit() {
      let that = this;

      //开始注入配置项
      wx.config({
        debug: false, //是否打开debug调试模式。
        appId: that.appId, //必填，公众号唯一标识
        timestamp: that.timestamp, //必填，生成签名的时间戳
        nonceStr: that.noncstr, //必填，生成签名的随机串
        signature: that.signatureInfo, //必填，生成的签名
        jsApiList: ['checkJsApi',
          'updateTimelineShareData',
          'updateAppMessageShareData',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
        ], //必填，允许分享好友，分享朋友圈
      });

      wx.ready(function () {
        // //分享到朋友圈的
        wx.updateTimelineShareData({
          title: that.title, // 分享标题
          link: that.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.imgurl, // 分享图标
          success: function () {
            console.log("已分享朋友圈成功");
          },
          fail: function () {
            console.log("分享朋友圈失败");
          },
        });

        // //分享给朋友的
        wx.updateAppMessageShareData({
          title: that.title, // 分享标题
          desc: that.desc, // 分享描述
          link: that.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.imgurl, // 分享图标
          type: '',
          dataUrl: '',
          success: function (res) {
            console.log("分享好友成功" + JSON.stringify(res));
          },
          fail: function (res) {
            console.log("分享好友失败" + JSON.stringify(res));
          },
        });

        wx.onMenuShareTimeline({
          //配置去分享朋友圈的选项
          title: that.title, //分享标题
          link: that.url, //分享链接
          imgUrl: that.imgurl, //分享图标
          success: function (res) {
            //分享成功
            that.$Toast("已分享朋友圈成功");
            //如分享成功后想做一些其他的业务处理，可以在这里做
          },
          cancel: function () {
            //that.alert="失败弹框话术等等(注意 这里拿不到this实例的)"
            that.$Toast("已分享失败");
          },
        });

        wx.onMenuShareAppMessage({
          //配置去分享好友的选项
          title: that.title,
          link: that.url,
          desc: that.desc,
          imgUrl: that.imgurl,
          success: function (res) {
            that.$Toast("分享好友成功");
          },
          cancel: function (res) {
            that.$Toast("分享失败");
          },
        });
      });
    },

    shareFriendTip() {
      this.$Toast("请点击右上角按钮进行分享");
    },

    handler({ BMap, map }) {
      var point = new BMap.Point(this.detailData.longitude, this.detailData.latitude);
      map.centerAndZoom(point, 25);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var circle = new BMap.Circle(point, 1, {
        strokeColor: "Red",
        strokeWeight: 1,
        strokeOpacity: 1,
        Color: "Red",
        fillColor: "#f03",
      });
      map.addOverlay(circle);
    },

    getClickInfo(latitude, longitude) {
      this.center.lng = longitude;
      this.center.lat = latitude;
    },

    //场地中心-改楼盘其他房源
    siteUserH5Detail(id) {
      var that = this;
      that.$api
        .siteUserH5DetailAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            let str = res.data.data.floor_name
            let index = str .lastIndexOf("/")
            res.data.data.floor_name = str.substring(0,index);
            res.data.data.siteCharacteristics_name =
              res.data.data.siteCharacteristics_name.split(",");
            /*let latitude = res.data.data.latitude
            let longitude = res.data.data.longitude*/
            that.detailData = res.data.data;
            that.isCollect = that.detailData.isCollect ? 'star':'star-o'
            /*that.detailData.latitude = longitude;
            that.detailData.longitude = latitude;*/
            that.getClickInfo(that.detailData.latitude, that.detailData.longitude);
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

    collect() {
      var that = this;
      that.$api
        .collectAPI({ id: that.detailId })
        .then(function (res) {
          if (res.data.data === 1) {
            that.$Notify({ type: "success", message: "收藏成功！" })
            that.isCollect = 'star'
          } else {
            that.$Notify({ type: "success", message: "取消收藏!" })
            that.isCollect = 'star-o'
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

    //场地中心-相似房源
    pxalike(id) {
      var that = this;
      that.$api
        .pxalikeAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            res.data.dataList.forEach((element) => {
              element.siteCharacteristics_name =
                element.siteCharacteristics_name.split(",");
            });
            that.detailData2 = res.data.dataList;
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

    //场地中心-改楼盘其他房源
    pclistBySiteSupplierId(id) {
      var that = this;
      that.$api
        .pclistBySiteSupplierIdAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            res.data.dataList.forEach((element) => {
              element.siteCharacteristics_name =
                element.siteCharacteristics_name.split(",");
            });
            that.detailData3 = res.data.dataList;
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

    // 滑动swiper
    changeSwiper(index) {
      console.log("index", index);
      this.isSwiperIndex = index + 1;
    },

    initMap() {
      let map = new BMapGL.Map("map_wrap"); // 创建Map实例
      map.centerAndZoom(new BMapGL.Point(113.403, 22.506), 16); // 初始化地图,设置中心点坐标和地图级别
      map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      // 创建点标记
      let marker1 = new BMapGL.Marker(new BMapGL.Point(113.403, 22.506));
      // 在地图上添加点标记
      // map.addOverlay(marker1);
      let scaleCtrl = new BMapGL.ScaleControl(); // 添加比例尺控件
      // map.addControl(scaleCtrl);
      let zoomCtrl = new BMapGL.ZoomControl(); // 添加缩放控件
      // map.addControl(zoomCtrl);
      let myKeys = ["酒店", "加油站", "公交站"];
      // let local = new BMapGL.LocalSearch(map, {
      //   renderOptions: { map: map, panel: "r-result" },
      //   pageCapacity: 5,
      // });
      local.searchInBounds(myKeys, map.getBounds());
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //跳转立即租赁
    toSiteLease() {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      setTimeout(function () {
        that.$Toast.clear();
        that.$router.push({
          path: "/home/siteLease",
          query: { id: that.detailId },
        });
      }, 1000)

    },

    //跳转立即预约
    toSiteSubscribe() {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      setTimeout(function () {
        that.$Toast.clear();
        that.$router.push({
          path: "/home/siteSubscribe",
          query: { id: that.detailId },
        });
      }, 1000)

    },

    toSiteDetail(id) {
      this.$router.push({ path: "/home/siteDetail", query: { id: id } });
      document.documentElement.scrollTop = 0;
      // this.$router.go(0);
    },

    toMapLocation() {
      let url = 'http://api.map.baidu.com/marker?location='+this.detailData.latitude+','+this.detailData.longitude+'&title='+this.detailData.name+'&content='+this.detailData.address+'&output=html'
      window.open(url)
    },
  },
};

</script>
<style lang="less" scoped>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 200px;
  text-align: center;
  background-color: #39a9ed;
}

// 视频+swiper
.detail_header {
  position: relative;
  display: flex;
  justify-content: center;

  .header_indicator {
    position: absolute;
    bottom: 10px;
    margin: auto;

    .indicator {
      color: #fff;
      font-size: 12px;
      border-radius: 1000px;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;

      div {
        padding: 3px 10px;
      }

      .active {
        background: #fc9829;
        border-radius: 1000px;
      }
    }
  }
}

// 详情内容
.detail_centent {
  display: flex;
  flex-direction: column;
  padding: 20px;

  .content_name {
    font-size: 18px;
    font-weight: bold;
  }

  .centent_data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 10px 10px;

    .data_number {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      flex-direction: column;
      position: relative;
      padding: 15px;
      width: 33%;

      & div:nth-child(1) {
        color: #e97357;
      }

      & div:nth-child(2) {
        font-size: 13px;
        color: #999;
        font-weight: normal;
      }
    }
  }

  .content_list {
    display: flex;
    flex-direction: column;
    font-size: 14px;

    .list_item {
      display: flex;
      align-items: center;
      margin-top: 10px;

      span {
        width: 50px;
        color: #999;
      }
    }

    .list_item_between {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;

      .between {
        display: flex;
        flex-direction: row;
        width: 50%;

        span {
          width: 50px;
          color: #999;
        }
      }
    }
  }

  .content_tag {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;

    .van-tag {
      margin-right: 7px;
      margin-top: 5px;
    }
  }

  .content_title {
    font-size: 17px;
    font-weight: bold;
    padding-top: 30px;
    padding-bottom: 20px;
  }

  .content_desc {
    font-size: 16px;
    color: #999;
  }
}

.detail_navbar {
  display: flex;
  position: fixed;
  height: 60px;
  align-items: center;
  bottom: 0px;
  background: #fff;
  justify-content: space-between;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 100%;

  .navbar_lsit {
    display: flex;
    flex-direction: column;
    color: #0cadfc;
    width: 50px;
    align-items: center;
    font-size: 11px;
  }

  .van-button {
    width: 120px;
    font-size: 15px;
    height: 40px;
    margin-right: 10px;
  }
}

#map_wrap {
  width: 100%;
  height: 250px;
  margin-top: 10px;
}

.content_tabname {
  display: flex;
  font-size: 15px;

  div {
    margin-right: 20px;
  }

  .active {
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      width: 35px;
      height: 3px;
      margin-top: 10px;
      margin-bottom: 10px;
      background: red;
    }
  }
}

// 列表菜单栏
.home_list {
  display: flex;
  flex-direction: column;

  .list_item {
    display: flex;
    flex-direction: column;

    .item_content {
      display: flex;
      flex-direction: row;
      padding: 10px 0px;
      border-bottom: 1px solid #f1f1f1;

      .content_img {
        position: relative;
        width: 150px;
        height: 100px;
        border-radius: 3px;
        overflow: hidden;

        .van-icon {
          position: absolute;
          bottom: 5px;
          right: 5px;
          background: rgba(0, 0, 0, 0.5);
          padding: 5px;
          border-radius: 100%;
        }
      }

      .content_detail {
        width: 250px;
        display: flex;
        flex-flow: column; //垂直排列
        justify-content: space-between; //两端对齐
        margin-left: 10px;

        /deep/ .detail_tag {
          display: flex;
          flex-wrap: wrap;

          .van-tag--plain {
            padding: 1px 3px;
            margin-right: 5px;
            margin-top: 5px;
          }
        }

        .detail_number {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          align-items: flex-end;

          .number {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/home/siteDetail.vue